import { render } from "./ContextMenu.vue?vue&type=template&id=039ec08e&scoped=true&ts=true"
import script from "./ContextMenu.vue?vue&type=script&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=039ec08e&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039ec08e"]])

export default __exports__